(function () {
  let timer;
  function money(cents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
  }

  function updateCartSummary(total) {
    document.querySelectorAll('[data-phc-cart-total-value]').forEach(function (target) {
      const formattedTotal = money(total);
      if (target.textContent !== formattedTotal) target.textContent = formattedTotal;
    });
    document.querySelectorAll('[data-phc-cart-quick-checkout]').forEach(function (button) {
      button.disabled = total <= 0;
    });
    document.querySelectorAll('[data-phc-cart-confidence]').forEach(function (section) {
      section.hidden = total <= 0;
    });
  }

  function syncMobileBuyBars() {
    document.querySelectorAll('product-info [data-phc-qualifying-bar]').forEach(bar => {
      document.querySelectorAll('body > [data-phc-qualifying-bar]').forEach(old => old.remove());
      document.body.appendChild(bar);
    });
    document.querySelectorAll('[data-phc-mobile-add]').forEach(function (mobileButton) {
      const target = document.getElementById(mobileButton.dataset.target);
      if (!target) return;
      const info = target.closest('product-info') || target.closest('section');
      const picker = info && info.querySelector('variant-selects');
      const data = picker && picker.querySelector('[data-selected-variant]');
      if (data) {
        try {
          const variant = JSON.parse(data.textContent);
          const bar = mobileButton.closest('[data-phc-mobile-buybar]');
          const name = bar && bar.querySelector('[data-phc-selection]');
          const price = bar && bar.querySelector('[data-phc-selection-price]');
          if (variant && name && price) {
            const addon = info.querySelector('phc-bundle-addon');
            const title = addon?.selection ? addon.dataset.summaryLabel : variant.title.replace('Fucshia', 'Fuchsia');
            const total = addon?.selection ? addon.total : variant.price;
            if (name.textContent !== title) name.textContent = title;
            if (price.textContent !== money(total)) price.textContent = money(total);
          }
        } catch (error) {}
      }
      const disabled = target.disabled || target.getAttribute('aria-disabled') === 'true';
      mobileButton.disabled = disabled;
      const sourceText = target.querySelector('span');
      const bundlePicker = info && info.querySelector('phc-simple-bundle-picker');
      const needsBundleChoice = bundlePicker && info.dataset.phcBundleChosen !== 'true';
      const label = needsBundleChoice ? bundlePicker.dataset.chooseLabel : (sourceText ? sourceText.textContent.trim() : '');
      if (label && mobileButton.textContent.trim() !== label) mobileButton.textContent = label;
    });
  }


  function updateOfferMessages(cart) {
    document.querySelectorAll('phc-cart-gifts').forEach(element => {
      if (typeof element.syncCart === 'function') element.syncCart(cart);
    });
  }

  function refresh() {
    if (!document.querySelector('[data-phc-cart-offer], [data-phc-cart-total-value], [data-phc-cart-confidence]')) return;
    fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        const total = cart.total_price || 0;
        updateCartSummary(total);
        updateOfferMessages(cart);

      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 180);
  }

  function init() {
    refresh();

    const observer = new MutationObserver(schedule);
    const cartDrawer = document.querySelector('cart-drawer');
    const mainCartItems = document.getElementById('main-cart-items');

    if (cartDrawer) {
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (mainCartItems) {
      observer.observe(mainCartItems, { childList: true, subtree: true });
    }

    document.addEventListener('cart:updated', schedule);
    document.addEventListener('phc:bundle-choice', syncMobileBuyBars);

    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      const buyBarObserver = new MutationObserver(function () {
        window.requestAnimationFrame(syncMobileBuyBars);
      });
      buyBarObserver.observe(productInfo, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      syncMobileBuyBars();
    }

    document.addEventListener('click', function (event) {
      const recommendationsOpen = event.target.closest('[data-phc-recommendations-open]');
      if (recommendationsOpen) {
        const modal = document.getElementById(recommendationsOpen.getAttribute('aria-controls'));
        if (modal) {
          if (typeof modal.showModal === 'function') modal.showModal();
          else modal.setAttribute('open', '');
        }
        return;
      }

      if (event.target.matches('[data-phc-recommendations-modal]')) {
        if (typeof event.target.close === 'function') event.target.close();
        else event.target.removeAttribute('open');
        return;
      }

      const mobileButton = event.target.closest('[data-phc-mobile-add]');
      if (!mobileButton) return;
      const target = document.getElementById(mobileButton.dataset.target);
      const info = target && target.closest('product-info');
      const bundlePicker = info && info.querySelector('phc-simple-bundle-picker');
      if (bundlePicker && info.dataset.phcBundleChosen !== 'true') {
        bundlePicker.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        bundlePicker.querySelector('[data-bundle-count][aria-pressed="true"]')?.focus({ preventScroll: true });
        return;
      }
      if (target && !target.disabled) target.click();
    });
  }

  function initWhenIdle() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(init, { timeout: 1600 });
    } else {
      window.setTimeout(init, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenIdle, { once: true });
  } else {
    initWhenIdle();
  }
})();

